import React from 'react'
import InlineTextEditor from '../../inline-editors/InlineTextEditor'
import { CellBaseProps, resolveOverrideContext, isFieldEditing, makeEditClickHandler, makeFieldSaveHandler, overrideEditableClass } from './types'

/**
 * Renders the Year/EIS (YOM/EIS) column cell with two editable rows:
 * year manufactured and year delivered.
 */
export function YearCell(props: CellBaseProps) {
  const { cellBorderClass, effectiveAircraft, aircraftTransaction } = props
  const { isSoldWithTransaction, isEditable, transOverride, override } = resolveOverrideContext(props)

  const hasYearMfrOverride = isSoldWithTransaction
    ? (transOverride?.year_manufactured != null)
    : (override?.year_manufactured != null)
  const hasYearDlvOverride = isSoldWithTransaction
    ? (transOverride?.year_delivered != null)
    : (override?.year_delivered != null)

  const currentYearMfr = isSoldWithTransaction
    ? (transOverride?.year_manufactured ?? effectiveAircraft.yearmfr ?? null)
    : (override?.year_manufactured ?? effectiveAircraft.yearmfr ?? null)
  const currentYearDlv = isSoldWithTransaction
    ? (transOverride?.year_delivered ?? aircraftTransaction!?.yeardlv ?? null)
    : (override?.year_delivered ?? effectiveAircraft.yeardlv ?? null)

  const isEditingYearMfr = isFieldEditing(props, 'year_manufactured', isSoldWithTransaction)
  const isEditingYearDlv = isFieldEditing(props, 'year_delivered', isSoldWithTransaction)

  return (
    <td className={`px-2 py-2 text-sm text-gray-900 text-center ${cellBorderClass}`}>
      <div
        className={overrideEditableClass(hasYearMfrOverride, isEditable)}
        onClick={makeEditClickHandler(props, 'year_manufactured', isEditable, isSoldWithTransaction)}
      >
        {isEditingYearMfr ? (
          <InlineTextEditor
            value={currentYearMfr}
            fieldName="year_manufactured"
            inputType="number"
            min={1900}
            placeholder="YYYY"
            onSave={makeFieldSaveHandler(props, 'year_manufactured', isSoldWithTransaction)}
            onCancel={props.handleCancelEdit}
          />
        ) : (
          effectiveAircraft.yearmfr || '-'
        )}
      </div>
      <div
        className={overrideEditableClass(hasYearDlvOverride, isEditable)}
        onClick={makeEditClickHandler(props, 'year_delivered', isEditable, isSoldWithTransaction)}
      >
        {isEditingYearDlv ? (
          <InlineTextEditor
            value={currentYearDlv}
            fieldName="year_delivered"
            inputType="number"
            min={1900}
            placeholder="YYYY"
            onSave={makeFieldSaveHandler(props, 'year_delivered', isSoldWithTransaction)}
            onCancel={props.handleCancelEdit}
          />
        ) : (
          effectiveAircraft.yeardlv || '-'
        )}
      </div>
    </td>
  )
}

